import { Dialog } from "@mui/material";
import { useEffect } from "react";
import { RxCrossCircled } from "react-icons/rx";

const ErrorAddCartPopup = ({ open, setOpen }) => {
  const handleClose = () => {
    setOpen(false);
  };

  useEffect(() => {
    if (open)
      setTimeout(() => {
        handleClose();
      }, 1500);
  }, [open]);

  return (
    <Dialog
      onClose={handleClose}
      open={open}
      PaperProps={{ sx: { borderRadius: "16px" } }}
    >
      <div className="flex gap-4 items-start p-4 bg-[#FFE7E7] text-[#C62828]">
        <RxCrossCircled className="text-[20px] mt-1" />
        <div className="w-full">
          <p className="text-[20px]">Qty Masih Kosong</p>
          <p className="text-[16px]">Tambah kuantitas terlebih dahulu</p>
        </div>
      </div>
    </Dialog>
  );
};

export default ErrorAddCartPopup;
